import React, { FC, useEffect } from 'react';
import { ServiceFAQs } from 'containers/common/sections/faq/index';
import { faqServiceImage } from 'assets/images/faq';
import { observer } from 'mobx-react-lite';
import commonStores from 'stores/common';
import { FaqProject } from 'services/cms/types';
import { NextRouter, useRouter } from 'next/router';
import { Box, Theme, useMediaQuery } from '@material-ui/core';
import useI18n from "evcharging/hooks/useI18n";

const FaqSections: FC = observer(() => {
  const { t } = useI18n();

  const { faqStore } = commonStores;
  const { retailFaqs, evcFaqs, ledFaqs, setIsOpen, isOpen, getProjectByQuestion } = faqStore;
  const onToggleAccordion = (prj: FaqProject) => () => setIsOpen(prj, !isOpen(prj));
  const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  const { asPath, push }: NextRouter = useRouter();
  const currentId = asPath.split('#')[1];

  useEffect(() => {
    (async () => {
      if (currentId) {
        const question = currentId.split('-').join(' ');
        const project = getProjectByQuestion(question);
        setIsOpen(project, true);
        await push('/faq#' + currentId);
      }
    })();
  }, []);

  return (
    <>
      {/*<ServiceFAQs*/}
      {/*  title={t('services.retail-energy')}*/}
      {/*  text={t('faq.service.retail-energy')}*/}
      {/*  imageSrc={faqServiceImage}*/}
      {/*  imageRight*/}
      {/*  faqs={retailFaqs}*/}
      {/*  onToggleAccordion={onToggleAccordion(FaqProject.retail)}*/}
      {/*  open={isOpen(FaqProject.retail)}*/}
      {/*/>*/}
      {/*<Box mb={isSmall ? 0 : 14} />*/}
      {/*<ServiceFAQs*/}
      {/*  title={t('services.lighting-retrofit')}*/}
      {/*  text={t('faq.service.lighting-retrofit')}*/}
      {/*  imageSrc={faqServiceImage}*/}
      {/*  faqs={ledFaqs}*/}
      {/*  onToggleAccordion={onToggleAccordion(FaqProject.led)}*/}
      {/*  open={isOpen(FaqProject.led)}*/}
      {/*/>*/}
      <Box mb={isSmall ? 0 : 14} />
      <ServiceFAQs
        title={t('services.ev-charging')}
        text={t('faq.service.ev-charging')}
        imageSrc={faqServiceImage}
        imageRight
        faqs={evcFaqs}
        onToggleAccordion={onToggleAccordion(FaqProject.evc)}
        open={isOpen(FaqProject.evc)}
      />
    </>
  );
});

export default FaqSections;
